/* Publish by EComposer at 2024-07-12 02:25:21*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kh94tudoix"]=  window.__ectimmers["ecom-kh94tudoix"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-kh94tudoix').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kh94tudoix', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h0ackhhfq7e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0ackhhfq7e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7tk895tqbu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7tk895tqbu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6v04xorfok7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6v04xorfok7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3xeobhz5izk"]=  window.__ectimmers["ecom-3xeobhz5izk"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-3xeobhz5izk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3xeobhz5izk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c3gerr8c5g9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c3gerr8c5g9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hccqfmnadk5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hccqfmnadk5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4uat9nj5zpj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4uat9nj5zpj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dqovu91fzpw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dqovu91fzpw', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}